import type { QuestionImageRef } from "../api/types";

/**
 * Reusable image gallery for question images. `kind` picks the right
 * endpoint: admin views fetch from the admin bytes route; student views
 * from the student route (which is assignment-gated).
 *
 * The browser handles loading + cookie-based auth on the <img src>; we
 * never carry image bytes through the SPA.
 */
export function QuestionImages({
  images,
  kind,
}: {
  images: QuestionImageRef[] | undefined;
  kind: "admin" | "student";
}) {
  if (!images || images.length === 0) return null;
  const base =
    kind === "admin" ? "/api/admin/question-images" : "/api/student/question-images";
  return (
    <div className="question-images">
      {images
        .slice()
        .sort((a, b) => a.position - b.position)
        .map((img) => (
          <img
            key={img.id}
            src={`${base}/${img.id}`}
            alt={img.alt_text ?? ""}
            className="question-image"
          />
        ))}
    </div>
  );
}
